var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 7.4L0 1.4L1.4 0L6 4.6L10.6 0L12 1.4L6 7.4Z","fill":"black"}));
}

ChevronDown.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
